import React from "react";

import styles from "./styles.module.scss";

const UniqName = (props) => {
  const { uniqName } = props;
  return uniqName?.passed === false && <div className={styles.validationText}>{uniqName.text}</div>;
};
export default UniqName;
